import React from "react";
import { question } from "../../../../../../Types";
import { useTourDataStore } from "../../../../../../api/Zustand";
import { Box, Flex } from "@react-three/flex";
import { Circle, Text } from "@react-three/drei";
import CloseBtn from "../../../FixedComponents/CloseBtn";
import * as THREE from "three";
import { textMeshMaterial } from "../XRImagePop";

const QuestionHeader = (props: { question: question }) => {
  const { tourData } = useTourDataStore();

  const questionIndex: number = React.useMemo(() => {
    const quizQuestions = tourData?.quizData?.data;

    const index = quizQuestions?.findIndex(
      (qu) => qu.questionId === props.question.questionId
    );
    return (index ?? 0) + 1;
  }, [tourData?.quizData, props.question.questionId]);

  return (
    <Box centerAnchor width={"100%"}>
      <Flex dir={"row"} justifyContent={"space-between"}>
        <Box>
          <Text
            fontSize={1}
            material={textMeshMaterial}
            renderOrder={3}
            fontWeight={800}
            textAlign="left"
          >
            {questionIndex}
          </Text>
          <Circle
            renderOrder={3}
            args={[1, 32]}
            material={circleMaterial}
            position={[0, 0, -0.2]}
          ></Circle>
        </Box>
      </Flex>
    </Box>
  );
};

export default QuestionHeader;
const circleMaterial = new THREE.MeshBasicMaterial({
  color: "#35a8e0",
  depthTest: false,
  transparent: true,
});
